/*
 * @Author: your name
 * @Date: 2021-12./pages/App6:41:56
 * @LastEditTime: 2021-12-21 16:53:28
 * @LastEditors: Please set LastEditors
 * @Description: 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 * @FilePath: \gw-react\src\index.js
 */
import React from "react";
import ReactDOM from "react-dom";
import App from "./pages/App";
import { HashRouter, BrowserRouter } from "react-router-dom";
// 导入自动播放和分页器模块
import SwiperCore, { Pagination, Autoplay, Navigation } from "swiper";
// 导入swiper组件样式
import "swiper/swiper.scss";
//如果当先项目导入scss文件报错，请百度搜索react项目引入scss文件，然后下载对应插件即可引入
// 导入分页器组件样式
import "swiper/components/pagination/pagination.scss";

import "./style/index.scss";
import "swiper/swiper.scss";
import "./rem";
import { TouchSlide } from "./TouchSlide";
import { Provider } from "react-redux";
import store from "./store";

// console.log("Touch", Touch);
// TouchSlide({
//   slideCell: "#bannerSlides",
//   titCell: ".bannerSlide_foncus",
//   mainCell: ".bannerSlide_container",
//   autoPage: "<span></span>",
//   effect: "leftLoop",
//   delayTime: 600,
//   interTime: 5000,
//   autoPlay: true,
//   titOnClassName: "active",
// });
// TouchSlide({
//   slideCell: "#tmSlides",
//   titCell: ".tmSlide_foncus",
//   mainCell: ".tmSlide_container",
//   autoPage: "<span></span>",
//   effect: "leftLoop",
//   delayTime: 600,
//   interTime: 5000,
//   autoPlay: true,
//   titOnClassName: "active",
// });
// import "lib-flexible";
document.title = "【伊百丽医学美肤连锁】（全国14院连锁）";
SwiperCore.use([Pagination, Autoplay, Navigation]);
ReactDOM.render(
  <Provider store={store}>
    <BrowserRouter>
      <App />
    </BrowserRouter>
  </Provider>,
  document.getElementById("root")
);
